import React from 'react';

import {
  BillingPublisherPayoutSettingsType,
  PayoutFeeOptionType,
} from '@ts/billing-publisher.types';

import {
  formatAmountInCurrency,
  formatEstimatedDelivery,
  formatUsd,
  getWithdrawButtonLabel,
  mapPaymentMethod,
} from '../../utils';

type Props = {
  amount: number;
  method: BillingPublisherPayoutSettingsType | undefined;
  feeOption: PayoutFeeOptionType | null;
};

function ConfirmSummary({ amount, method, feeOption }: Props): JSX.Element {
  return (
    <div className="withdraw-form__confirm-summary" role="status">
      <div className="withdraw-form__confirm-title">
        You’re about to withdraw <strong>{formatUsd(amount)}</strong> to{' '}
        <strong>{getWithdrawButtonLabel(method)}</strong>.
      </div>
      <ul className="withdraw-form__confirm-list">
        <li>
          <span>Method</span>
          <span>{mapPaymentMethod(method)}</span>
        </li>
        <li>
          <span>Amount</span>
          <span>{formatUsd(amount)}</span>
        </li>
        {feeOption && (
          <>
            <li>
              <span>Transfer fee</span>
              <span>{formatAmountInCurrency(feeOption.feeTotal, feeOption.feeCurrency)}</span>
            </li>
            <li>
              <span>Recipient gets</span>
              <span>
                {formatAmountInCurrency(feeOption.targetAmount, feeOption.targetCurrency)}
              </span>
            </li>
            {feeOption.estimatedDelivery && (
              <li>
                <span>Estimated arrival</span>
                <span>{formatEstimatedDelivery(feeOption.estimatedDelivery)}</span>
              </li>
            )}
          </>
        )}
      </ul>
      <div className="withdraw-form__confirm-disclaimer">
        Once confirmed, this withdrawal can’t be cancelled.
      </div>
    </div>
  );
}

export default ConfirmSummary;
